// console.log(this.$parameterConfig.p_channelid[item.channelid],

var p_channelid = {
    '0001': '代销中心',
    '0002': '东方广场',
    '0103': '银联-农行',
    '0104': '银联-中行',
    '0105': '银联-建行',
    '0120': '汇款-工行',
    '0301': '银联-交行',
    '0302': '银联-中行',
    '0303': '银联-光大',
    '0304': '银联-华夏银行',
    '0305': '汇款-民生网点',
    '0306': '银联-广发',
    '0307': '银联-深发展',
    '0308': '银联-招行',
    '0309': '银联-兴业银行',
    '0310': '银联-浦发',
    '0311': '银联-邮政储蓄',
    '0313': '银联-烟台银行',
    '0316': '银联-浙商银行',
    '0317': '银联-渤海银行',
    '0401': '银联-上海银行',
    '0403': '银联-北京银行',
    '0408': '银联-宁波银行',
    '0410': '银联-平安银行',
    '0412': '银联-温州银行',
    '0414': '银联-汉口银行',
    '0418': '银联-洛阳银行',
    '0420': '银联-大连银行',
    '0423': '银联-杭州银行',
    '0424': '银联-南京银行',
    '0427': '银联-乌鲁商行',
    '0440': '银联-徽商银行',
    '0442': '银联-哈尔滨银行',
    '0450': '银联-青岛银行',
    '0508': '银联-江苏银行',
    '0530': '银联-浙稠州商行',
    '1103': '汇款-农行',
    '1104': '汇款-中行',
    '1105': '汇款-建行',
    '1301': '汇款-交行',
    '1302': '汇款-中行',
    '1303': '汇款-光大',
    '1304': '汇款-华夏银行',
    '1305': '银联-民生',
    '1306': '汇款-广发',
    '1307': '汇款-深发',
    '1308': '汇款-招行',
    '1309': '汇款-兴业银行',
    '1310': '汇款-浦发',
    '1311': '汇款-邮政储蓄',
    '1313': '汇款-烟台银行',
    '1316': '汇款-浙商银行',
    '1317': '汇款-渤海银行',
    '1318': '汇款-中信银行',
    '1401': '汇款-上海银行',
    '1403': '汇款-北京银行',
    '1408': '汇款-宁波银行',
    '1410': '汇款-平安银行',
    '1412': '汇款-温州银行',
    '1414': '汇款-汉口银行',
    '1418': '汇款-洛阳银行',
    '1420': '汇款-大连银行',
    '1423': '汇款-杭州银行',
    '1424': '汇款-南京银行',
    '1427': '汇款-乌鲁商业',
    '1440': '汇款-徽商银行',
    '1442': '汇款-哈尔滨银行',
    '1450': '汇款-青岛银行',
    '1508': '汇款-江苏银行',
    '1530': '汇款-浙商行',
    '3333': '汇款支付网点',
    '6441': '银联-重庆银行',
    '7001': '快钱-工商银行',
    '7002': '快钱-农业银行',
    '7003': '快钱-建设银行',
    '7004': '快钱-中国银行',
    '7005': '快钱-平安银行',
    '7006': '快钱-兴业银行',
    '7007': '快钱-浦发银行',
    '7008': '快钱-交通银行',
    '7009': '快钱-华夏银行',
    '7010': '快钱-中信银行',
    '7011': '快钱-光大银行',
    '7012': '快钱-招商银行',
    '7101': '富友-工行',
    '7102': '富友-农行',
    '7103': '富友-建行',
    '7104': '富友-中行',
    '7105': '富友-平安银行',
    '7106': '富友-兴业银行',
    '7107': '富友-浦发银行',
    '7108': '富友-交行',
    '7109': '富友-邮储',
    '7110': '富友-中信银行',
    '7111': '富友-光大银行',
    '7112': '富友-招行',
    '7113': '富友-广发',
    '7114': '富友-华夏',
    '7441': '汇款-重庆银行',
    '8401': '易宝-光大银行',
    '8402': '易宝-建设银行',
    '8403': '易宝-农业银行',
    '8404': '易宝-中国银行',
    '8405': '易宝-温州银行',
    '8406': '易宝-工商银行',
    '8408': '易宝-平安银行',
    '8409': '易宝-兴业银行',
    '8410': '易宝-交通银行',
    '8411': '易宝-中信银行',
    '8866': '民生网点',
    '8880': '汇付天下网点',
    '8882': '工行网点',
    '8884': '农行网点',
    '8886': '建行网点',
    '8888': '银联网点',
    '9001': '通联-光大银行',
    '9002': '通联-平安银行',
    '9003': '通联-浦发银行',
    '9004': '通联-工商银行',
    '9005': '通联-农业银行',
    '9006': '通联-上海银行',
    '9007': '通联-邮储银行',
    '9008': '通联-温州银行',
    '9009': '通联-交通银行',
    '9010': '通联-民生银行',
    '9011': '通联-中国银行',
    '9012': '通联-建设银行',
    '9013': '通联-大连银行',
    '9014': '通联-汉口银行',
    '9015': '通联-重庆银行',
    '9016': '通联-广发银行',
    '9017': '通联-兴业',
}

var p_sharetype = {
    'A': '前收费',
    'B': '后收费'
}



var p_fundtype = {
    '0': '股票型基金',
    '1': '债券型基金',
    '2': '货币型基金',
    '3': '混合型基金',
    '4': '专户基金',
    '5': '指数型基金',
    '6': 'QDII基金',
    '7': 'FOF',
}



var p_transstatus = {
    '0': '正常',
    '1': '待确认',
    '2': '销户中',
    '3': '销户',
    '7': '开户失败',
    '8': '复核锁定',
}


var p_planstatus = {
    'C': '客户主动终止',
    'D': '系统作废',
    'N': '正常',
    'P': '暂停',
    'W': '待确认',
    'X': '未知',
}



var p_minorflag = {
    '0': '否',
    '1': '是',
}


var p_investtime = {
    '0': '终止日期',
    '1': '扣款期数',
}




var p_selltime = {
    '0': '终止日期',
    '1': '执行期数',
}




var p_investperiods = {
    '0': '月',
    '1': '周',
    '2': '天',
}





var p_investmode = {
    '1': '按递增金额扣款',
    '2': '按后续投资金额不变',
}




var p_zstype = {
    '0': '上证综指',
    '1': '深证成指',
    '2': '沪深300',
    '6': '中证红利',
}






var p_sellmode = {
    '2': '自定义份额',
    '3': '全部可用份额',
}




var p_largeredemption = {
    '0': '取消',
    '1': '顺延',
}




var p_appstatus = {
    '00': '待复核',
    '01': '待勾兑',
    '02': '待报',
    '04': '废单',
    '05': '已撤',
    '06': '已报',
    '07': '已确认',
    '08': '已结束',
}

var p_cardstatus = {
    '00': '待复核',
    '01': '未构成',
    '02': '未报',
    '03': '待撤销',
    '04': '废单',
    '05': '已撤销',
    '06': '已报',
    '07': '已确认',
    '08': '已结束',
}



var p_bizcode = {
    '01': '基金账户开户',
    '02': '基金账户销户',
    '03': '账户信息修改',
    '04': '基金账户冻结',
    '05': '基金账户解冻',
    '06': '基金账户挂失',
    '07': '基金账户解挂失',
    '08': '基金账户登记',
    '09': '交易账户销户',
    '14': '账户资料核对',
    '20': '认购',
    '22': '买入',
    '24': '卖出',
    '25': '预约赎回',
    '26': '转托管',
    '27': '转托管转入',
    '28': '转托管转出',
    '29': '设置分红方式',
    '30': '认购结果',
    '31': '基金份额冻结',
    '32': '基金份额解冻',
    '33': '非交易过户',
    '34': '非交易过户入',
    '35': '非交易过户出',
    '36': '基金转换',
    '37': '基金转换入',
    '38': '基金转换出',
    '39': '定期定额申购', //
    '42': '强行赎回',
    '43': '分红',
    '44': '份额强增', //强行调增
    '45': '份额强减', //强行调减
    '49': '基金募集失败',
    '50': '基金清盘',
    '51': '批量开户',
    '53': '撤预约单',
    '58': '变更交易账户',
    '59': '定投协议开通',
    '60': '定投协议撤销',
    '61': '定投协议变更',
    '63': '定期定额赎回',
    '69': '定赎/定转开通',
    '70': '定赎/定转撤销',
    '71': '定期赎回变更',
    '80': '确权',
    '91': 'ETF一次申购',
    '92': 'ETF二次申购',
    '93': 'ETF一次赎回',
    '94': 'ETF二次赎回',
    '95': '赎回支付',
    '96': '销交易账户',
    '98': 'T+0快速赎回',
    '99': '点财通会员返现',
    'A1': '客户联合开户',
    'A2': '客户销户',
    'A3': '增加银行卡',
    'A4': '客户冻结',
    'A5': '客户解冻',
    'A6': '客户密码修改',
    'A7': '客户更换银行卡',
    'A8': '客户银行卡资料修改',
    'A9': '经办人资料维护',
    'B1': '客户资料修改',
    'B2': '客户密码重置',
    'B4': '客户挂失',
    'B5': '客户解挂',
    'B6': '注销银行卡',
    'B8': '客户解锁',
    'B9': '客户实时资料修改',
    'C2': '份额调增',
    'C3': '份额调减',
    'C4': '银行卡身份证转换',
    'C5': '银行卡签约',
    'C6': '银行卡解约',
    'G1': '定时定额暂停',
    'G2': '定时定额恢复',
    'G3': '定时赎回暂停',
    'G4': '定时赎回恢复',
}


var p_certificatetype = {
    '0': '身份证',
    '1': '护照',
    '2': '军官证',
    '3': '士兵证',
    '4': '港澳居民来往内地通行证',
    '5': '户口本',
    '6': '外国护照',
    '7': '其它',
    '8': '文职证',
    '9': '警官证',
    'A': '台胞证',
}













var p_educationlevel = {
    '01': '研究生',
    '02': '大学本科',
    '03': '大学专科',
    '04': '中专或技校',
    '05': '技工学校',
    '06': '高中',
    '07': '初中',
    '08': '小学',
    '09': '文盲或半文盲',
}










var p_vocationcode = {
    '01': '党政机关、事业单位',
    '02': '企业单位',
    '03': '自由业主',
    '04': '学生',
    '05': '军人',
    '06': '其他',
}








var p_delivertype = {
    '1': '不寄送',
    '2': '按月',
    '3': '按季',
    '4': '半年',
    '5': '一年',
}







var p_annualincome = {
    '01': '2万以下',
    '02': '2-10万',
    '03': '10-20万',
    '04': '20-50万',
    '05': '50万以上',
}







var p_deliverway = {
    '1': '邮寄',
    '3': 'E-mail',
    '5': '电子传真',
}





var p_defdividendmethod = {
    '0': '红利再投',
    '1': '现金分红',
}



var p_sex = {
    '0': '女',
    '1': '男',
}




var p_risklevel = {
    '01': '保守型',
    '02': '稳健型',
    '03': '平衡型',
    '04': '成长型',
    '05': '进取型',
}







var p_fundlevel = {
    '01': '低风险',
    '02': '中低风险',
    '03': '中风险',
    '04': '中高风险',
    '05': '高风险',
}


var p_fundstatus = {
    '0': '交易',
    '1': '发行',
    '2': '发行成功',
    '3': '发行失败',
    '4': '基金停止交易',
    '5': '停止申购',
    '6': '停止赎回',
    '7': '权益登记',
    '8': '红利发放',
    '9': '基金封闭',
    'a': '基金终止',
    'b': '限制大额申购',
}

var p_distributor = {
    '001': '中国人民银行',
    '002': '中国工商银行',
    '003': '中国农业银行',
    '004': '中国银行',
    '005': '中国建设银行',
    '006': '交通银行',
    '007': '招商银行',
    '010': '深圳发展银行',
    '011': '福建兴业银行',
    '014': '民生银行',
    '202': '国泰直销',
    '205': '博时直销',
    '207': '嘉实直销',
    '209': '大成直销',
    '213': '宝盈基金管理有限公司',
    '218': '银华直销',
    '227': '广发直销',
    '240': '东方直销',
    '244': '前海开源基金管理有限公司',
    '247': '汇添富直销',
    '258': '东吴直销',
    '259': '中邮直销',
    '261': '信达澳银基金管理有限公司',
    '269': '民生加银基金管理有限公司',
    '286': '东海基金直销中心',
    '302': '深圳众禄基金销售有限公司',
    '362': '上海基玉投资管理有限公司',
    '408': '国寿安保',
    '410': '展恒基金',
    '422': '中金基金管理有限公司',
    '447': '北信瑞丰',
    '452': '九泰基金',
    '502': '兴证期货',
    '601': '国泰君安证券股份公司',
    '602': '华夏证券公司',
    '603': '国信证券',
    '604': '招商证券股份公司',
    '605': '广发证券公司',
    '606': '中信证券股份公司',
    '607': '中国银河证券有限公司',
    '608': '海通证券',
    '609': '联合证券有限公司',
    '610': '申银万国',
    '613': '兴业证券',
    '614': '长江证券',
    '615': '广东证券',
    '622': '渤海证券',
    '623': '大鹏证券',
    '624': '华泰证券',
    '625': '山西证券',
    '629': '汉唐证券',
    '630': '北京证券',
    '631': '东方证券',
    '634': '长城证券',
    '635': '光大证券',
    '645': '金信证券',
    '646': '平安证券',
    '650': '东莞证券',
    '652': '国都证券',
    '999': '证券交易所',
}


var p_zsnumber = {
    '100': '100点',
    '1000': '1000点',
    '200': '200点',
    '50': '50点',
}


var p_subjectindex = {
    '18': '180日均线',
    '25': '250日均线',
    '50': '500日均线',
}

var p_chargecycle = {
    '0': '每月',
    '1': '每周',
    '2': '每双周',
}





var p_perweek = {
    '1': '周一',
    '2': '周二',
    '3': '周三',
    '4': '周四',
    '5': '周五',
}

var p_perdoubleweek = {
    '1': '周一',
    '2': '周二',
    '3': '周三',
    '4': '周四',
    '5': '周五',
}
var p_pertenday = {
    '01': '第1天',
    '02': '第2天',
    '03': '第3天',
    '04': '第4天',
    '05': '第5天',
    '06': '第6天',
    '07': '第7天',
    '08': '第8天',
    '09': '第9天',
    '10': '第10天',
}


var p_projectid = {
    '1': '指数区间扣款方案1',
}



var p_investmentperiod = {
    '10': '10年',
    '15': '15年',
    '3': '3年',
    '5': '5年',
    '8': '8年',
}

var p_investexpectvalue = {
    '0': '自定义',
    '10': '10万',
    '20': '20万',
    '30': '30万',
    '40': '40万',
}


var p_valueflag = {
    '0': '昨日收盘指数小于标的指数',
    '1': '昨日收盘指数大于标的指数',
}


var p_beforestatus = {
    '0': '未处理',
    '1': '下单成功',
    '2': '下单失败',
    '3': '撤单作废',
    '4': '等待签约',
    '5': '签约失败',
    '6': '正在处理',
    '7': '系统作废',
    '8': '待确认',
}


var p_investkind = {
    '0': '固定值',
    '1': '比例',
}


var p_investtype = {
    '0': '日期',
    '1': '指数',
    '2': '单位净值',
}


var p_investcond = {
    '0': '>=',
    '1': '<',
}


var p_businesskind = {
    '0': '普通业务',
    '1': '预约业务',
    '2': '赎回转认购',
    '3': '钱柜充值提现',
    '6': '赎回转申购',
    'd': '快速赎回转账费',
}

var p_businesskindex = {
    '00': '普通业务',
    '20': '老基换新基',
    '21': '充值买新基',
    '30': '充值提现货币',
    '40': '充值买基金',
    '99': '未知业务',
}


var p_paychannels = {
    '0010': '银联渠道',
    '0102': '工行渠道',
    '0103': '农行渠道',
    '0105': '建行渠道',
    '0108': '民生渠道',
    '0203': '汇付天下渠道',
    '0204': '易宝支付渠道',
    '0205': '快钱渠道',
    '0206': '富友渠道',
    '0302': '通联渠道',
    '2000': '汇款支付渠道',
}



var p_delivertype2 = {
    '1': '不寄送',
    '2': '按月',
    '3': '按季',
    '4': '半年',
    '5': '一年',
}


var p_indexreferencevalue = {
    '1000': '1000点',
    '2000': '2000点',
    '3000': '3000点',
    '4000': '4000点',
    '5000': '5000点',
    '6000': '6000点',
}


var p_saveplanflag = {
    '1': '普通定投',
    '2': '智能定投',
    '3': '智能定投',
    '4': '智能定投',
    '5': '智能定投',
    '6': '智能定投',
    'a': '组合定投',
    'b': '组合定转',
}


var p_rate = {
    '20': '20%可用份额',
    '40': '40%可用份额',
    '60': '60%可用份额',
    '80': '80%可用份额',
    'A': '100%可用份额',
    'B': '自定义份额',
}

var p_combsppro = {
    '10': '10%',
    '20': '20%',
    '30': '30%',
    '40': '40%',
    '50': '50%',
    '60': '60%',
    '70': '70%',
    '80': '80%',
    '90': '90%',
}


var p_day = {
    '02': '每2天',
    '03': '每3天',
    '04': '每4天',
    '05': '每5天',
    '06': '每6天',
    '07': '每7天',
    '08': '每8天',
    '09': '每9天',
    '10': '每10天',
    '11': '每11天',
    '12': '每12天',
    '13': '每13天',
    '14': '每14天',
    '15': '每15天',
    '16': '每16天',
    '17': '每17天',
    '18': '每18天',
    '19': '每19天',
    '20': '每20天',
    '21': '每21天',
    '22': '每22天',
    '23': '每23天',
    '24': '每24天',
    '25': '每25天',
    '26': '每26天',
    '27': '每27天',
    '28': '每28天',
}


var p_week = {
    '02': '每2周',
    '03': '每3周',
    '04': '每4周',
    '05': '每5周',
    '06': '每6周',
    '07': '每7周',
    '08': '每8周',
}


var p_month = {
    '02': '每2月',
    '03': '每3月',
    '04': '每4月',
    '05': '每5月',
    '06': '每6月',
    '07': '每7月',
    '08': '每8月',
    '09': '每9月',
    '10': '每10月',
    '11': '每11月',
    '12': '每12月',
}


var p_paytype = {
    '1': '银行卡转账',
    '2': '银行卡汇款',
    '3': '货币转换方式',
}


var p_orgcertificatetype = {
    '0': '组织机构代码证',
    '1': '营业执照',
    '2': '行政机关',
    '3': '社会团体',
    '4': '军队',
    '5': '武警',
    '6': '下属机构',
    '7': '基金会',
    '8': '其它机构',
    '9': '税务登记证明',
    'a': '注册登记证书号码',
}

var p_profession = {
    '党政机关负责人及管理人员': '1',
    '企事业单位负责人及管理人员': '2',
    '民主党派和工商联负责人及管理人员': '3',
    '人民团体或群众团体负责人及管理人员': '4',
    '社会组织（社会团体、基金会、社会服务机构、外国商会等）负责人及管理人员': '5',
    '科学研究及教学人员': '6',
    '文学艺术、体育专业人员': '7',
    '新闻出版、文化专业人员': '8',
    '卫生专业技术人员': '9',
    '工程、农业专业人员': '10',
    '法律、会计、审计、税务专业人员': '11',
    '经济和金融专业人员': '12',
    '宗教人士等特殊职业人员': '13',
    '其他专业技术人员': '14',
    '党政机关、企事业单位行政工作人员': '15',
    '民主党派、工商联、人民团体或社会组织等单位工作人员': '16',
    '人民警察、消防、应急救援人员': '17',
    '批发与零售服务人员': '18',
    '房地产服务人员': '19',
    '旅游、住宿和餐饮服务人员': '20',
    '珠宝、黄金等贵金属行业服务人员': '21',
    '文化、体育和娱乐服务人员': '22',
    '典当、拍卖行业服务人员': '23',
    '艺术品或文物收藏行业服务人员': '24',
    '废品、旧货回收服务人员': '25',
    '交通运输、仓储、邮政业服务人员': '26',
    '信息运输、软件和信息技术服务人员': '27',
    '居民、健康服务人员': '28',
    '其他社会生产和社会服务人员': '29',
    '农、林、牧、渔业生产及辅助人员': '30',
    '生产制造及有关人员': '31',
    '军人': '32',
    '国际组织工作人员': '33',
    '离退休人员': '34',
    '个体工商户（含淘宝店自营等）': '35',
    '无业': '36',
    '学生': '37'
}

var p_acceptmethod = {
    '0': '柜台',
    '2': '网上交易',
    '3': '传真',
}


var p_trademethod = {
    '0': '柜台',
    '1': '电话',
    '2': '网上交易',
    '3': '传真',
    '4': '手机',
    '5': '微信',
    '7': '第三方接入',
}


var p_agentcertificatetype = {
    '0': '身份证',
    '1': '护照',
    '2': '军官证',
    '3': '士兵证',
    '4': '港澳居民来往内地通行证',
    '5': '户口本',
    '6': '外国护照',
    '7': '其它',
    '8': '文职证',
    '9': '警官证',
    'A': '台胞证',
}


var p_investmove = {
    '10': '10%',
    '20': '20%',
    '30': '30%',
}


var p_busitype = {
    '0': '存入',
    '1': '取出',
    '2': '买基金',
    '3': '钱柜定投',
    '4': '自动充值',
    '5': '预约自动取现',
}


var p_frozencause = {
    '0': '司法冻结',
    '1': '柜台冻结',
    '2': '质押冻结',
    '3': '质押、司法双重冻结',
    '4': '柜台、司法双重冻结',
}





var p_orgchannelid = {
    '0010': '银联渠道',
    '0102': '工行渠道',
    '0103': '农行渠道',
    '0105': '建行渠道',
    '0108': '民生渠道',
    '0202': '支付宝',
    '0203': '汇付天下渠道',
    '0204': '易宝支付渠道',
    '0205': '快钱支付',
    '0206': '富友支付',
    '0302': '通联渠道',
    '1000': '代销中心',
    '2000': '汇款支付渠道',
}


var p_fund_cust = {
    '01': '01',
    '02': '01:02',
    '03': '01:02:03',
    '04': '01:02:03:04',
    '05': '01:02:03:04:05',
}


var p_provincename = {
    '安徽省': '安徽省',
    '澳门': '澳门',
    '北京市': '北京市',
    '福建省': '福建省',
    '甘肃省': '甘肃省',
    '广东省': '广东省',
    '广西壮族自治区': '广西壮族自治区',
    '贵州省': '贵州省',
    '海南省': '海南省',
    '河北省': '河北省',
    '河南省': '河南省',
    '黑龙江省': '黑龙江省',
    '湖北省': '湖北省',
    '台湾省': '台湾省',
    '天津市': '天津市',
    '西藏自治区': '西藏自治区',
    '香港特别行政区': '香港特别行政区',
    '新疆维吾尔族自治区': '新疆维吾尔族自治区',
    '云南省': '云南省',
    '浙江省': '浙江省',
    '重庆市': '重庆市',
    '湖南省': '湖南省',
    '吉林省': '吉林省',
    '江苏省': '江苏省',
    '江西省': '江西省',
    '辽宁省': '辽宁省',
    '内蒙古自治区': '内蒙古自治区',
    '宁夏回族自治区': '宁夏回族自治区',
    '其他': '其他',
    '青海省': '青海省',
    '山东省': '山东省',
    '山西省': '山西省',
    '陕西省': '陕西省',
    '上海市': '上海市',
    '四川省': '四川省',
}


var p_city = {
    '安庆市': '安徽省',
    '蚌埠市': '安徽省',
    '巢湖市': '安徽省',
    '池州市': '安徽省',
    '滁州市': '安徽省',
    '阜阳市': '安徽省',
    '合肥市': '安徽省',
    '淮北市': '安徽省',
    '淮南市': '安徽省',
    '黄山市': '安徽省',
    '六安市': '安徽省',
    '马鞍山市': '安徽省',
    '宿州市': '安徽省',
    '铜陵市': '安徽省',
    '芜湖市': '安徽省',
    '宣城市': '安徽省',
    '亳州市': '安徽省',
    '澳门': '澳门',
    '北京市': '北京市',
    '福州市': '福建省',
    '龙岩市': '福建省',
    '南平市': '福建省',
    '宁德市': '福建省',
    '莆田市': '福建省',
    '泉州市': '福建省',
    '三明市': '福建省',
    '厦门市': '福建省',
    '漳州市': '福建省',
    '白银市': '甘肃省',
    '定西市': '甘肃省',
    '甘南市': '甘肃省',
    '嘉裕关市': '甘肃省',
    '金昌市': '甘肃省',
    '酒泉市': '甘肃省',
    '兰州市': '甘肃省',
    '临夏市': '甘肃省',
    '陇南市': '甘肃省',
    '平凉市': '甘肃省',
    '庆阳市': '甘肃省',
    '天水市': '甘肃省',
    '武威市': '甘肃省',
    '张掖市': '甘肃省',
    '潮州市': '广东省',
    '东莞市': '广东省',
    '佛山市': '广东省',
    '广州市': '广东省',
    '河源市': '广东省',
    '惠州市': '广东省',
    '江门市': '广东省',
    '揭阳市': '广东省',
    '茂名市': '广东省',
    '梅州市': '广东省',
    '清远市': '广东省',
    '汕头市': '广东省',
    '汕尾市': '广东省',
    '韶关市': '广东省',
    '深圳市': '广东省',
    '阳江市': '广东省',
    '云浮市': '广东省',
    '湛江市': '广东省',
    '肇庆市': '广东省',
    '中山市': '广东省',
    '珠海市': '广东省',
    '百色市': '广西壮族自治区',
    '北海市': '广西壮族自治区',
    '崇左市': '广西壮族自治区',
    '防城港市': '广西壮族自治区',
    '桂林市': '广西壮族自治区',
    '贵港市': '广西壮族自治区',
    '河池市': '广西壮族自治区',
    '贺州市': '广西壮族自治区',
    '来宾市': '广西壮族自治区',
    '柳州市': '广西壮族自治区',
    '南宁市': '广西壮族自治区',
    '钦州市': '广西壮族自治区',
    '梧州市': '广西壮族自治区',
    '玉林市': '广西壮族自治区',
    '安顺市': '贵州省',
    '毕节市': '贵州省',
    '贵阳市': '贵州省',
    '六盘水市': '贵州省',
    '黔东南州': '贵州省',
    '黔南州': '贵州省',
    '黔西南州': '贵州省',
    '铜仁市': '贵州省',
    '遵义市': '贵州省',
    '海口市': '海南省',
    '三亚市': '海南省',
    '保定市': '河北省',
    '沧州市': '河北省',
    '承德市': '河北省',
    '邯郸市': '河北省',
    '衡水市': '河北省',
    '廊坊市': '河北省',
    '秦皇岛市': '河北省',
    '石家庄市': '河北省',
    '唐山市': '河北省',
    '邢台市': '河北省',
    '张家口市': '河北省',
    '安阳市': '河南省',
    '鹤壁市': '河南省',
    '济源市': '河南省',
    '焦作市': '河南省',
    '开封市': '河南省',
    '洛阳市': '河南省',
    '南阳市': '河南省',
    '平顶山市': '河南省',
    '三门峡市': '河南省',
    '商丘市': '河南省',
    '新乡市': '河南省',
    '信阳市': '河南省',
    '许昌市': '河南省',
    '郑州市': '河南省',
    '周口市': '河南省',
    '驻马店市': '河南省',
    '漯河市': '河南省',
    '濮阳市': '河南省',
    '大庆市': '黑龙江省',
    '大兴安岭地区': '黑龙江省',
    '哈尔滨市': '黑龙江省',
    '鹤岗市': '黑龙江省',
    '黑河市': '黑龙江省',
    '鸡西市': '黑龙江省',
    '佳木斯市': '黑龙江省',
    '牡丹江市': '黑龙江省',
    '七台河市': '黑龙江省',
    '齐齐哈尔市': '黑龙江省',
    '双鸭山市': '黑龙江省',
    '绥化市': '黑龙江省',
    '伊春市': '黑龙江省',
    '鄂州市': '湖北省',
    '恩施土家族苗族自治州': '湖北省',
    '黄冈市': '湖北省',
    '黄石市': '湖北省',
    '荆门市': '湖北省',
    '荆州市': '湖北省',
    '潜江市': '湖北省',
    '神农架林区': '湖北省',
    '十堰市': '湖北省',
    '随州市': '湖北省',
    '天门市': '湖北省',
    '武汉市': '湖北省',
    '仙桃市': '湖北省',
    '咸宁市': '湖北省',
    '襄樊市': '湖北省',
    '孝感市': '湖北省',
    '宜昌市': '湖北省',
    '高雄市': '台湾省',
    '高雄县': '台湾省',
    '花莲县': '台湾省',
    '基隆市': '台湾省',
    '嘉义市': '台湾省',
    '嘉义县': '台湾省',
    '苗栗县': '台湾省',
    '南投县': '台湾省',
    '澎湖县': '台湾省',
    '屏东县': '台湾省',
    '台北市': '台湾省',
    '台北县': '台湾省',
    '台东县': '台湾省',
    '台南市': '台湾省',
    '台南县': '台湾省',
    '台中市': '台湾省',
    '台中县': '台湾省',
    '桃园县': '台湾省',
    '新竹市': '台湾省',
    '新竹县': '台湾省',
    '宜兰县': '台湾省',
    '云林县': '台湾省',
    '彰化县': '台湾省',
    '天津市': '天津市',
    '阿里地区': '西藏自治区',
    '昌都地区': '西藏自治区',
    '拉萨市': '西藏自治区',
    '林芝地区': '西藏自治区',
    '那曲地区': '西藏自治区',
    '日喀则地区': '西藏自治区',
    '山南地区': '西藏自治区',
    '香港': '香港特别行政区',
    '阿克苏地区': '新疆维吾尔族自治区',
    '阿勒泰地区': '新疆维吾尔族自治区',
    '巴音郭楞蒙古自治州': '新疆维吾尔族自治区',
    '博尔塔拉蒙古自治州': '新疆维吾尔族自治区',
    '昌吉回族自治州': '新疆维吾尔族自治区',
    '哈密地区': '新疆维吾尔族自治区',
    '和田地区': '新疆维吾尔族自治区',
    '喀什地区': '新疆维吾尔族自治区',
    '克拉玛依市': '新疆维吾尔族自治区',
    '克孜勒苏柯尔克孜自治州': '新疆维吾尔族自治区',
    '塔城地区': '新疆维吾尔族自治区',
    '吐鲁番地区': '新疆维吾尔族自治区',
    '乌鲁木齐市': '新疆维吾尔族自治区',
    '伊犁哈萨克自治州': '新疆维吾尔族自治区',
    '保山市': '云南省',
    '楚雄市': '云南省',
    '大理市': '云南省',
    '德宏市': '云南省',
    '迪庆市': '云南省',
    '红河市': '云南省',
    '昆明市': '云南省',
    '丽江市': '云南省',
    '临沧市': '云南省',
    '怒江市': '云南省',
    '普洱市': '云南省',
    '曲靖市': '云南省',
    '文山市': '云南省',
    '西双版纳市': '云南省',
    '玉溪市': '云南省',
    '昭通市': '云南省',
    '杭州市': '浙江省',
    '湖州市': '浙江省',
    '嘉兴市': '浙江省',
    '金华市': '浙江省',
    '丽水市': '浙江省',
    '宁波市': '浙江省',
    '绍兴市': '浙江省',
    '台州市': '浙江省',
    '温州市': '浙江省',
    '舟山市': '浙江省',
    '衢州市': '浙江省',
    '重庆市': '重庆市',
    '常德市': '湖南省',
    '长沙市': '湖南省',
    '郴州市': '湖南省',
    '衡阳市': '湖南省',
    '怀化市': '湖南省',
    '娄底市': '湖南省',
    '邵阳市': '湖南省',
    '湘潭市': '湖南省',
    '湘西土家族苗族自治州': '湖南省',
    '益阳市': '湖南省',
    '永州市': '湖南省',
    '岳阳市': '湖南省',
    '张家界市': '湖南省',
    '株洲市': '湖南省',
    '白城市': '吉林省',
    '白山市': '吉林省',
    '长春市': '吉林省',
    '吉林市': '吉林省',
    '辽源市': '吉林省',
    '四平市': '吉林省',
    '松原市': '吉林省',
    '通化市': '吉林省',
    '延边朝鲜族自治州': '吉林省',
    '常州市': '江苏省',
    '淮安市': '江苏省',
    '连云港市': '江苏省',
    '南京市': '江苏省',
    '南通市': '江苏省',
    '苏州市': '江苏省',
    '宿迁市': '江苏省',
    '泰州市': '江苏省',
    '无锡市': '江苏省',
    '徐州市': '江苏省',
    '盐城市': '江苏省',
    '扬州市': '江苏省',
    '镇江市': '江苏省',
    '抚州市': '江西省',
    '赣州市': '江西省',
    '吉安市': '江西省',
    '景德镇市': '江西省',
    '九江市': '江西省',
    '南昌市': '江西省',
    '萍乡市': '江西省',
    '上饶市': '江西省',
    '新余市': '江西省',
    '宜春市': '江西省',
    '鹰潭市': '江西省',
    '鞍山市': '辽宁省',
    '本溪市': '辽宁省',
    '朝阳市': '辽宁省',
    '大连市': '辽宁省',
    '丹东市': '辽宁省',
    '抚顺市': '辽宁省',
    '阜新市': '辽宁省',
    '葫芦岛市': '辽宁省',
    '锦州市': '辽宁省',
    '辽阳市': '辽宁省',
    '盘锦市': '辽宁省',
    '沈阳市': '辽宁省',
    '铁岭市': '辽宁省',
    '营口市': '辽宁省',
    '阿拉善盟': '内蒙古自治区',
    '巴彦淖尔盟': '内蒙古自治区',
    '包头市': '内蒙古自治区',
    '赤峰市': '内蒙古自治区',
    '鄂尔多斯市': '内蒙古自治区',
    '呼和浩特市': '内蒙古自治区',
    '呼伦贝尔市': '内蒙古自治区',
    '科尔沁区': '内蒙古自治区',
    '通辽市': '内蒙古自治区',
    '乌海市': '内蒙古自治区',
    '乌兰察布盟': '内蒙古自治区',
    '锡林郭勒盟': '内蒙古自治区',
    '兴安盟': '内蒙古自治区',
    '伊克昭盟': '内蒙古自治区',
    '哲里木盟': '内蒙古自治区',
    '固原市': '宁夏回族自治区',
    '石嘴山市': '宁夏回族自治区',
    '吴忠市': '宁夏回族自治区',
    '银川市': '宁夏回族自治区',
    '中卫市': '宁夏回族自治区',
    '其他': '其他',
    '果洛州': '青海省',
    '海北州': '青海省',
    '海东地区': '青海省',
    '海南州': '青海省',
    '海西州': '青海省',
    '黄南州': '青海省',
    '西宁市': '青海省',
    '玉树州': '青海省',
    '滨州市': '山东省',
    '德州市': '山东省',
    '东营市': '山东省',
    '菏泽市': '山东省',
    '济南市': '山东省',
    '济宁市': '山东省',
    '莱芜市': '山东省',
    '聊城市': '山东省',
    '临沂市': '山东省',
    '青岛市': '山东省',
    '日照市': '山东省',
    '泰安市': '山东省',
    '威海市': '山东省',
    '潍坊市': '山东省',
    '烟台市': '山东省',
    '枣庄市': '山东省',
    '淄博市': '山东省',
    '长治市': '山西省',
    '大同市': '山西省',
    '晋城市': '山西省',
    '晋中市': '山西省',
    '临汾市': '山西省',
    '吕梁市': '山西省',
    '朔州市': '山西省',
    '太原市': '山西省',
    '忻州市': '山西省',
    '阳泉市': '山西省',
    '运城市': '山西省',
    '安康市': '陕西省',
    '宝鸡市': '陕西省',
    '汉中市': '陕西省',
    '商洛市': '陕西省',
    '铜川市': '陕西省',
    '渭南市': '陕西省',
    '西安市': '陕西省',
    '咸阳市': '陕西省',
    '延安市': '陕西省',
    '榆林市': '陕西省',
    '上海市': '上海市',
    '阿坝州': '四川省',
    '巴中市': '四川省',
    '成都市': '四川省',
    '达州市': '四川省',
    '甘孜州': '四川省',
    '广安市': '四川省',
    '广元市': '四川省',
    '乐山市': '四川省',
    '凉山市': '四川省',
    '眉山市': '四川省',
    '绵阳市': '四川省',
    '南充市': '四川省',
    '内江市': '四川省',
    '攀枝花市': '四川省',
    '遂宁市': '四川省',
    '雅安市': '四川省',
    '宜宾市': '四川省',
    '资阳市': '四川省',
    '自贡市': '四川省',
    '泸州市': '四川省',
}


var p_country = {
    '156': '中国',
}


var p_tano = {
    '08': '长盛基金',
    '25': '国联安基金',
    '18': '银华基金',
    '48': '工银瑞信基金',
    '02': '国泰基金',
    '40': '东方基金',
    '47': '汇添富基金',
    '99': '上海中登',
    '27': '广发基金',
    '05': '博时基金',
    '21': '金鹰基金',
    '59': '中邮基金',
    '98': '深证中登',
    '06': '鹏华基金',
    '10': '富国基金',
    '19': '万家基金',
    '56': '益民基金',
    '57': '诺德基金',
    '26': '景顺长城基金',
    '42': '天弘基金',
    '31': '申万菱信基金',
    '63': '华商基金',
    '17': '招商基金',
    '76': '国金通用基金',
    '36': '光大保德信基金',
    '12': '国投瑞银基金',
    '45': '国海富兰克林基金',
    '41': '华富基金',
    '77': '德邦基金',
    '46': '华泰柏瑞基金',
    '23': '海富通基金',
    '20': '长城基金',
    '64': '浦银安盛基金',
    '39': '中海基金',
    '43': '新华基金',
    '0N': '国开泰富基金',
    '78': '红塔红土基金',
    '0B': '东海基金',
    '07': '嘉实基金',
    '55': '信诚基金',
    '3J': '北信瑞丰',
    '03': '华夏基金',
    '0Z': '国寿安保基金管理',
    '74': '长安基金',
    '44': '前海开源基金',
    '61': '信达澳银基金',
    '72': '财通基金',
    '69': '民生加银基金',
    'AE': '第一创业证券股份',
    '0F': '中融基金',
    '37': '上投摩根基金',
    '32': '诺安基金',
    '33': '摩根士丹利基金',
    '0L': '鑫元基金',
    '60': '中欧基金',
    '68': '浙商基金',
    '3Z': '东兴证券',
    '4L': '中科沃土',
    '04': '华安基金',
    '11': '易方达基金',
    '15': '银河基金',
    '0A': '华润元大基金',
    '1N': '中金基金',
    '3K': '山西证券',
    '54': '汇丰晋信基金',
    '65': '英大基金',
    '01': '南方基金',
    '22': '泰达宏利基金',
    '16': '融通基金',
    '35': '天治基金',
    '0D': '中加基金',
    '49': '交银施罗德基金',
    '0W': '上海东方证券',
    '91': '上海东方证券',
    '73': '方正富邦基金公司',
    '1M': '兴业基金',
    '3R': '嘉合基金',
    '5D': '格林基金',
    'H0': '天弘基金云TA',
    '4K': '新沃基金',

}

var p_custmanagerid = {
    'compete01': '实盘基金大赛',
    'jjds_jsbank2': '晋商二队',
    'compete02': '实盘大赛二期',
    'jjds_qzbank': '泉州商行',
    'jjds_jsbank': '晋商一队',
    'jjds_nchbank': '南充商行',
    'jjds_dzbank': '德州商行',
}


var p_branchcode = {
    '308': '展恒基金',
}






export default {
    p_channelid,
    p_sharetype,
    p_fundtype,
    p_transstatus,
    p_planstatus,
    p_minorflag,
    p_investtime,
    p_selltime,
    p_investperiods,
    p_investmode,
    p_zstype,
    p_sellmode,
    p_largeredemption,
    p_appstatus,
    p_bizcode,
    p_certificatetype,
    p_educationlevel,
    p_vocationcode,
    p_delivertype,
    p_annualincome,
    p_deliverway,
    p_defdividendmethod,
    p_sex,
    p_risklevel,
    p_fundlevel,
    p_fundstatus,
    p_distributor,
    p_zsnumber,
    p_subjectindex,
    p_chargecycle,
    p_perweek,
    p_perdoubleweek,
    p_pertenday,
    p_projectid,
    p_investmentperiod,
    p_investexpectvalue,
    p_valueflag,
    p_beforestatus,
    p_investkind,
    p_investtype,
    p_investcond,
    p_businesskind,
    p_businesskindex,
    p_paychannels,
    p_delivertype2,
    p_indexreferencevalue,
    p_saveplanflag,
    p_rate,
    p_combsppro,
    p_day,
    p_week,
    p_month,
    p_paytype,
    p_orgcertificatetype,
    p_acceptmethod,
    p_trademethod,
    p_agentcertificatetype,
    p_investmove,
    p_busitype,
    p_frozencause,
    p_orgchannelid,
    p_fund_cust,
    p_provincename,
    p_city,
    p_country,
    p_tano,
    p_custmanagerid,
    p_branchcode,
    p_cardstatus,
    p_profession
}